module.exports = __webpack_public_path__ + "static/media/immuno.8e81eb6c.png";